
const selectors = {
  instanFeed: document.getElementById('index-instagram-feed')
};
class templalteIndexJS {
  constructor() {
  	if(selectors.instanFeed) this.manageInstaJS();
    if (document.querySelectorAll("[close-watch-trailer]").length > 0) {
      document.querySelector("[close-watch-trailer] a").addEventListener("click",(event)=>{

        event.preventDefault();
        document.querySelector("#ModalClose-video").click();
        let currentTarget = event.target;
        let getStartedBtn = currentTarget.getAttribute("href");
        let linkTarget = document.querySelector(`${getStartedBtn}`);
        let menuHeight = document.querySelector(".site-header").clientHeight;
        window.scrollTo(0, linkTarget.offsetTop-menuHeight+1);

      });
    }
    setTimeout((e)=>{
      if(window.location.href.indexOf('#green') >= 0){
        let goGreenSection = document.querySelector('.shopify-section.image-text-style');
        let elementPosition = goGreenSection.getBoundingClientRect().top;
        let navigationHeight =document.querySelector("[main-navigation]").offsetHeight;
        let offsetPosition = elementPosition + window.pageYOffset - navigationHeight;
        if(goGreenSection){
          goGreenSection.scrollIntoView({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    }, 500)
  }

  manageInstaJS(){
      const onIntersection = (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              let instaScript = document.createElement('script');
              instaScript.src = "https://instafeed.nfcube.com/cdn/96df1231132a33486b7559f1245a551b.js";
              instaScript.dataset.shopname = "crunchlabsstore.myshopify.com";
              document.body.appendChild(instaScript);
              observer.disconnect();
            }
          }
      };
      const observer = new IntersectionObserver(onIntersection);
      observer.observe(selectors.instanFeed);
  }
}
typeof templalteIndexJS !== 'undefined' && new templalteIndexJS();

